import React, { useEffect } from "react";
import Routes from "./Routes/index";
import WhatsAppButton from "../../ClientApp/src/components/WhatsApp";
import './assets/scss/theme.scss';
import { informationService } from "./api/getInformationService";

function App() {

    useEffect(() => {
        const isLoggedIn = localStorage.getItem("token");
        const existingNumber = localStorage.getItem("salesPersonWA");

        if (!isLoggedIn && !existingNumber) {
            informationService.WaNumber();
        }
    }, []);

    return (
        <React.Fragment>
            <Routes />
            <WhatsAppButton />
        </React.Fragment>
    );
}

export default App;
